import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeriesPoint } from './op-chart-series-point'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'


export class OpChartSeries {
    //Properties
    public xName: string
    public yName: string
    public xCaption: OpDescr
    public yCaption: OpDescr
    public seriesName: string
    public seriesCaption: OpDescr
    public seriesType: Enums.ChartType
    public seriesColor: string
    public seriesPoints: OpChartSeriesPoint[]
    public xTypeName: string
    public yTypeName: string
    public referenceType: Enums.ReferenceType

    public xIdDataTypeFormat: number
    public yIdDataTypeFormat: number
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.xName = opObj.XName
            this.yName = opObj.YName
            this.xCaption = opObj.XCaption
            this.yCaption = opObj.yCaption
            this.seriesName = opObj.SeriesName
            if (opObj.SeriesCaption)
                this.seriesCaption = new OpDescr(opObj.SeriesCaption)
            this.seriesType = opObj.SeriesType
            if (opObj.SeriesColor)
                this.seriesColor = Utils.getHexColorFromSystemDrawingColor(opObj.SeriesColor)
            if (opObj.SeriesPoints)
                this.seriesPoints = opObj.SeriesPoints.map(data => new OpChartSeriesPoint(data))
            this.xTypeName = opObj.XTypeName
            this.yTypeName = opObj.YTypeName
            this.referenceType = opObj.ReferenceType
            this.xIdDataTypeFormat = opObj.XIdDataTypeFormat
            this.yIdDataTypeFormat = opObj.YIdDataTypeFormat
        }
        if (!this.seriesPoints)
            this.seriesPoints = []
    }
}